export default "/static/dashboard/build/app/img/v2/b1f2bf2f4e4097a780993e752010c0f3.png";